// src/polyfills.ts
(window as any).global = window; // Define global
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
import * as process from 'process';
(window as any).process = process;
import 'zone.js';